import { UserProduct } from '../services/api.types';

export const formatAdminProductDate = (
  dateString: string,
  copy: { postedToday: string; postedOn: string },
) => {
  try {
    if (!dateString) return '';
    const date = new Date(dateString);
    const today = new Date();
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const time = date.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' });
    if (dateOnly.getTime() === todayOnly.getTime()) {
      return copy.postedToday.replace('{time}', time);
    }
    const formattedDate = date.toLocaleDateString('ro-RO', {
      day: '2-digit', month: 'long', year: 'numeric',
    });
    return copy.postedOn.replace('{date}', formattedDate).replace('{time}', time);
  } catch (err) {
    console.error('Error formatting date:', err);
    return '';
  }
};

export const formatAdminProductPrice = (product: Pick<UserProduct, 'price'> | null | undefined) => {
  try {
    if (!product?.price) return '';
    return `${product.price.price} ${product.price.currency} / ${product.price.unitType}`;
  } catch (err) {
    console.error('Error formatting price:', err);
    return '';
  }
};
